module.exports = __webpack_public_path__ + "static/img/knowledge2.99aa72e3.png";